// extracted by mini-css-extract-plugin
module.exports = {"color-picker":"_3Aaeyu"};